__turbopack_context__.v({
  "active": "badge-module-scss-module__PNz1Mq__active",
  "badge": "badge-module-scss-module__PNz1Mq__badge",
  "inactive": "badge-module-scss-module__PNz1Mq__inactive",
  "label": "badge-module-scss-module__PNz1Mq__label",
});
